import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { createBrowserRouter, createMemoryRouter } from 'react-router'
import { routes } from './routes'
import './index.css'

/**
 * The single-file preview (--mode demo) runs inside a sandboxed frame where the
 * URL can't be relied on, so it routes in memory. A plain "#course" style anchor
 * on the shared link still opens that page first. Every other build uses real URLs.
 */
function initialDemoPath() {
  const token = window.location.hash.replace(/^#\/?/, '')
  return /^[a-z-]+$/.test(token) ? `/${token}` : '/'
}

const router = import.meta.env.MODE === 'demo' ? createMemoryRouter(routes, { initialEntries: [initialDemoPath()] }) : createBrowserRouter(routes)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
